import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { axiosGet, axiosPost } from "../../api/Axios";

const initialState: IChatState = {
  isSubmitting: false,
  error: null,
  userChat: [],
  meta: null,
  isAbleToChat: false,
};
export const getMyChats = createAsyncThunk(
  "/chats/getMyChats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosGet<IMessage[]>(`/chats/getMyChats`);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getMetaChatMeta = createAsyncThunk(
  "/chats/getMeta",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosGet<ChatMetaRes>(`/chats/getMeta`);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const isUserAbleToChat = createAsyncThunk(
  "/chats/isUserAbleToChat",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosGet<{ isAbleToChat: boolean }>(
        `/chats/isUserAbleToChat`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Create the auth slice
const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    pushNewMessage: (state, action: PayloadAction<IMessage>) => {
      state.userChat.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getMyChats.pending, (state) => {
        state.isSubmitting = true; // Set isSubmitting to true while the request is pending
        state.error = null; // Reset error
      })
      .addCase(getMyChats.fulfilled, (state, action) => {
        state.isSubmitting = false;
        state.userChat = action.payload;
      })
      .addCase(getMyChats.rejected, (state, action) => {
        state.isSubmitting = false;
        state.error = action.payload as string; // Set the error message
      })
      .addCase(getMetaChatMeta.pending, (state) => {
        state.isSubmitting = true; // Set isSubmitting to true while the request is pending
        state.error = null; // Reset error
      })
      .addCase(getMetaChatMeta.fulfilled, (state, action) => {
        state.isSubmitting = false;
        state.meta = action.payload;
      })
      .addCase(getMetaChatMeta.rejected, (state, action) => {
        state.isSubmitting = false;
        state.error = action.payload as string; // Set the error message
      })
      .addCase(isUserAbleToChat.pending, (state) => {
        state.isSubmitting = true; // Set isSubmitting to true while the request is pending
        state.error = null; // Reset error
      })
      .addCase(isUserAbleToChat.fulfilled, (state, action) => {
        state.isSubmitting = false;
        state.isAbleToChat = action.payload.isAbleToChat;
      })
      .addCase(isUserAbleToChat.rejected, (state, action) => {
        state.isSubmitting = false;
        state.error = action.payload as string; // Set the error message
      });
  },
});

// Export actions and reducer
export const { pushNewMessage } = chatSlice.actions;
export default chatSlice.reducer;
